import { object, string } from 'yup';

export const appLoginEmailSchema = object({
  app_login_email: string()
    .trim()
    .email('App login email must be a valid email address')
    .typeError('App login email must be a string')
    .notRequired()
    .nullable()
    .label('App login email')
});
